import { atomWithHash } from '@/atoms/atomWithHash';
import { FilterSettings, TemplateCommunitySortBy } from '@/types';
import { atom } from 'jotai';

// Sort, filter, and pagination atoms for Forms Community
export const formsSelectedSortAtom = atom<TemplateCommunitySortBy>(
  TemplateCommunitySortBy.MOST_POPULAR
);

export const formsSelectedLocationAtom = atom<string | FilterSettings>(
  FilterSettings.INITIAL
);

export const formsSelectedSpecialtyAtom = atom<string | FilterSettings>(
  FilterSettings.INITIAL
);

export const formsSearchStringAtom = atom<string>('');

export const formsPageAtom = atom<number>(1);

export const importedFormIdAtom = atomWithHash<string | null>('importedFormId', null, {
  setHash: 'replaceState',
});

// Atom to track if form filling is in progress (for the upload modal flow)
export const formFillingInProgressAtom = atom<boolean>(false);

// Atom to store temporary session ID after anonymous form fill
export const tempFormSessionIdAtom = atom<string | null>(null);

// Atom to store the filled form preview URL
export const filledFormPreviewUrlAtom = atom<string | null>(null);
